export class AuthError extends Error {
  constructor(message: string = 'Authentication failed') {
    super(message);
    this.name = 'AuthError';
  }
}

export class NetworkError extends Error {
  public readonly retries: number;
  public readonly lastStatus: number | undefined;

  constructor(message: string, retries: number = 0, lastStatus: number | undefined = undefined) {
    super(message);
    this.name = 'NetworkError';
    this.retries = retries;
    this.lastStatus = lastStatus;
  }
}

export interface SocketHandle {
  send: (data: string | ArrayBuffer) => void;
  close: () => void;
  onMessage: (handler: (data: string | ArrayBuffer) => void) => void;
  onClose: (handler: (code?: number, reason?: string) => void) => void;
  onReconnect: (handler: () => void) => void;
}
